import API from './index';

export const sendSupportMessage = (params = {}) =>
  API.post(`/support_send_message`, params);
